import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom'
import {sectionIndex, sectionStore} from '../../features/dashboard/SectionOneSlice';
import Loading from '../../Loading';
import Header from './Header';
import Input from '../form/Input';
import { Calendar } from "react-multi-date-picker";
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import SectionOneEditModel from './SectionOneEditModel'
import DataTable, { ExpanderComponentProps } from 'react-data-table-component';
import Broadcast from './Broadcast';
import * as Icon from 'react-feather';
import $ from 'jquery'
import Button from "../form/Button";
import {archiveIndex} from "../../features/dashboard/ArchiveSlice";
import * as moment from 'jalali-moment';
import { ToastContainer, toast } from 'react-toastify';
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'

function ArchiveSectionOneIndex() {
    const columns = [
        {
            name: '#',
            cell: (row, index) => <div className='rahpardaznet-border'>{index + 1} </div>,

        },
        {

            name: 'نام',
            cell: row => <div className='rahpardaznet-border'>{row.title}</div>
        },

        {
            name: 'تاریخ ایجاد',
            cell: row => <div className="rahpardaznet-border">{moment(row.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}</div>
        },
        {
            name: 'تاریخ بروزرسانی',
            cell: row => <div className="rahpardaznet-border">{moment(row.updated_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}</div>
        },
        {
            name: 'عملیات',
            cell: row => <div className='rahpardaznet-table-btn'>  
                <span>
                    <a 
                        className='rahpardaznet-icon-table' 
                        onClick={(event) => editHandler(event.target.id, row.title, row.flag)}
                        data-tooltip-id={"tooltip-edit-"+row.id}
                        data-tooltip-content='ویرایش نام انبار'
                        data-tooltip-place="top"
                    >
                        <i className="fa-regular fa-pen-to-square fa-fw" id={row.id}></i>
                    </a>
                    <Tooltip id={"tooltip-edit-"+row.id} style={{ backgroundColor: "#767676", color: "#fff" }} />
                </span>
                <span>
                    <Link 
                        to={`/dashboard/archive/section/two/index/${row.id}`} 
                        className='rahpardaznet-icon-table'
                        data-tooltip-id={"tooltip-show-"+row.id}
                        data-tooltip-content='نمایش بخش های میانی'
                        data-tooltip-place="top"
                    >
                        <i className="fa-regular fa-eye fa-fw"></i>
                    </Link>
                    <Tooltip id={"tooltip-show-"+row.id} style={{ backgroundColor: "#767676", color: "#fff" }} />
                </span>
            </div>
        },
    ];
    // $data = SectionOne::orderByRaw('RAND()')->get();
    // $data = SectionOne::inRandomOrder()->get();
    const [page, setPage] = useState(1);
    const countPerPage = 20;
    const param = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const token = localStorage.getItem('token')
    const date = new DateObject({ calendar: persian, locale: persian_fa })

    let {
        sections,
        archiveSectionOneLoading,
        archiveSectionOneSuccess,
        errorTitle,
        message,
        rahpardaznetLoading,
        success,
        CreateMessage
    } = useSelector(state => state.sectionOne)
    const [edit, setEdit] = useState()
    const [title, setTitle] = useState()
    const [name, setName] = useState()
    const [flag, setFlag] = useState()
    let [modalShow, setModalShow] = useState(false)
    const editHandler = (id, name, plag) => {
        setEdit(id)
        setName(name)
        setFlag(plag)
        setModalShow(true)
        message = ''

    }
    const updateHandler = (event) => {
        // console.log(event)
    }

    const closeButtonHandler = () => {
        message = ' '
        
        setModalShow(false)
    }
    useEffect(() => {
        if (modalShow === false) {
            message = ''
        }

        if(archiveSectionOneSuccess === true && message != "") {
            toast.success(message, {
                position: "top-center",
                autoClose: 600,
            })
            setTitle('')
            message = ''
            getUserList()
        }
        message = ''
        return () => {
            message = ''
        }

    }, [archiveSectionOneSuccess, message])  
     useEffect(() => {
      

        if(CreateMessage != "") {
            toast.success(CreateMessage, {
                position: "top-center",
                autoClose: 600,
            })
        }
      
    }, [CreateMessage])


    



    const getUserList = async (search = pinCode, pageNumber = page) => {

        const data = {
            'pageNumber': pageNumber,
            'countPerPage': countPerPage,
            'search': search,
            'section': param.section
        }
        dispatch(sectionIndex(data))

    };
    function searchByDataTable(event) {
        let delayTimeOutFunction;
        delayTimeOutFunction = setTimeout(() => {
            getUserList(event.target.value);


        }, 3000); // denounce delay

        return () => clearTimeout(delayTimeOutFunction);

    };
    const [pinCode, setPinCode] = useState("");
    useEffect(() => {
        getUserList()
    }, []);
    const rahkarpardaznet_search_datatable = (e) => {
        e.preventDefault();
        setPage(1);

        $('#pagination-first-page').trigger('click');
        getUserList(pinCode, 1);
    }

    const handlePageChange = (page) => {
        setPage(page);
        getUserList('', page);
    };

    const sectionOneHandler = (event) => {
        event.preventDefault();
        const data = {
            'store_id': param.section,
            'title': title,
            'access': localStorage.getItem('access')
        }
        dispatch(sectionStore(data));
    }


    useEffect(() => {
        if (rahpardaznetLoading) {
            $('.dlUCce').addClass('loading');
        } else {
            $('.dlUCce').removeClass('loading');
        }


        console.log(sections);

    }, [rahpardaznetLoading])

    return (
        <>
            {archiveSectionOneLoading === true ? (<Loading />) : null}
            <Broadcast title={'مدیریت بخش های انبار | بخش اصلی'} />
            <div className='row rahpardaznet-cart  my-5  print-position'>
                <Header title='افزودن انبار (بخش اصلی)' />
                <div className='row'>
                    <div className='col-12 d-flex'>
                        <div className="rahpardaz-search-form-select border-radius-0">
                        <Input
                            key='2'
                            tab='2'
                            col='col-12'
                            type='text'
                            maxlength={255}
                            name='number'
                            value={title}
                            title='عنوان'
                            onchange={(e) => setTitle(e.target.value)}
                            placeholder='مانند : ساختمان کویر موتور'
                            errorName={errorTitle}
                        />
                        <Button
                            tab='3'
                            title='ثبت بخش اصلی'
                            design="rahpardaznet-search-btn"
                            event={sectionOneHandler}
                        />
                        </div>





                    </div>
                </div>

            </div>
                <div className='row g-2 pr-3 pl-3 pb-4'>

                    <div className="App">
                        <div className='row'>
                            <div className='col-12 col-md-6'>
                                <form onSubmit={rahkarpardaznet_search_datatable} className="rk-search-bar">
                                    <input type="text" id="" placeholder='جستجو کنید' onChange={(event) => setPinCode(event.target.value)} />
                                                                <button type="submit"><Icon.Search /></button>

                                </form>                            </div>
                            <div className='col-12 col-md-6 text-left align-self-center'>
                                <Link to={`/dashboard/archive/index/`} className='rahpardaznet-btn-back'>برگشت</Link>
                            </div>
                        </div>

                        <DataTable
                            title=""
                            columns={columns}
                            data={(typeof sections == 'object') ? sections.data : []}
                            className='rahpardaznet-table-user'
                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={(typeof sections == 'object') ? sections.total : []}
                            paginationPerPage={countPerPage}
                            paginationComponentOptions={{
                                noRowsPerPage: true
                            }}
                            onChangePage={handlePageChange}
                        />
                    </div>


                </div>


            <SectionOneEditModel
                header='ویرایش  بخش اصلی انبار'
                id={edit}
                title={name}
                flag={flag}
                // model='sectionOne'
                // message={message}
                // loading={archiveSectionOneLoading}
                show={modalShow}
                onHide={() => closeButtonHandler()}
            />
        </>
    )
}

export default ArchiveSectionOneIndex;